import { render, staticRenderFns } from "./R10_polymer.vue?vue&type=template&id=d66ff000&scoped=true"
import script from "./R10_polymer.vue?vue&type=script&lang=js"
export * from "./R10_polymer.vue?vue&type=script&lang=js"
import style0 from "./R10_polymer.vue?vue&type=style&index=0&id=d66ff000&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66ff000",
  null
  
)

export default component.exports